{
  "account": {"open": "Account menu of {{name}}"},
  "back": "Back",
  "backKey": "Back (Esc)",
  "closeSidebar": "Close sidebar",
  "column": {"hide": "Hide {{column}}", "show": "Show {{column}}"},
  "openSidebar": "Open sidebar",
  "resizeSidebar": "Resize the sidebar",
  "sectionsNavigation": "Sections",
  "sidebar": "Sidebar",
  "tabs": {
    "activeGroup": "The group you work in",
    "choose": "Choose a tab",
    "close": "Close",
    "closeNamed": "Close {{name}}",
    "closeOthers": "Close others",
    "count_one": "{{count}} tab",
    "count_other": "{{count}} tabs",
    "failed": "This page could not be shown.",
    "more": "More tabs",
    "moveBeside": "Move to the side",
    "moveGroup": "Move this group",
    "newTab": "New tab",
    "openBeside": "Open beside",
    "openNewTab": "Open in new tab",
    "page": {
      "batch": "Batch",
      "importProposal": "Import proposal",
      "item": "Item",
      "problemReport": "Report a problem",
      "review": "Review"
    },
    "preparationTitle": "{{heading}}: {{name}}",
    "recentlyClosed": "Recently closed",
    "resize": "Resize the groups",
    "retry": "Try again",
    "workflowTitle": "Process schema: {{name}}"
  }
}
